module.exports = __webpack_public_path__ + "static/media/sf_attraction_pier39.dbbdb716.jpg";